import { render } from "./Advantages.vue?vue&type=template&id=0e31b0d7&scoped=true&ts=true"
import script from "./Advantages.vue?vue&type=script&lang=ts"
export * from "./Advantages.vue?vue&type=script&lang=ts"

import "./Advantages.vue?vue&type=style&index=0&id=0e31b0d7&lang=scss&scoped=true"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e31b0d7"]])

export default __exports__